const beforeUpload = (
  context,
  file,
  maxSize = 2,
  proportions = null,
  acceptedFormats = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'],
) => {
  if (!file.type.startsWith('image/')) {
    const isValid = acceptedFormats.includes(file.type)
    if (!isValid) {
      context.$message.error('Invalid file format')
      return false
    }

    const isLt = file.size / 1024 / 1024 < maxSize
    if (!isLt) {
      context.$message.error(`The file must be less than ${maxSize}MB`)
      return false
    }

    return true
  }

  const IncorrectImageFormat = acceptedFormats.includes(file.type)
  if (!IncorrectImageFormat) {
    context.$message.error('You can only upload JPG, JPEG, PNG or WEBP file!')
    return false
  }
  return new Promise((resolve, reject) => {
    const _URL = window.URL || window.webkitURL
    const img = new Image()
    img.src = _URL.createObjectURL(file)
    img.onload = (err) => {
      const isLt2M = file.size / 1024 / 1024 < maxSize
      if (!isLt2M) {
        context.$message.error(`Image must smaller than ${maxSize}MB!`)
        reject(err)
        return
      }
      if (proportions) {
        const inProportions = Math.round(10 * (img.width / img.height)) / 10 === 1
        if (!inProportions) {
          context.$message.error(`Image must be in correct proportions - 1 : 1 (e.g. ${proportions} x ${proportions} px)`)
          reject(err)
        } else {
          file.status = 'done'
          resolve()
        }
      }
      resolve()
    }
  })
}

const getBase64 = (img, callback) => {
  const reader = new FileReader()
  reader.addEventListener('load', () => callback(reader.result))
  reader.readAsDataURL(img)
}

export { beforeUpload, getBase64 }
